import styled from 'styled-components';

import { branchTermSingular } from 'utils/terminology';
import { Arrow, Circle } from 'assets/icons';
import { ctaGreen } from 'constants/variables';
import SimilarStockItemsCarousel from 'components/similar_stock/similar_stock_items_carousel';

/**
 * Renders a <V2SimilarStock/> component
 * @param {Object} props
 * @param {Array} props.similarStockItems - Array items to be rendered
 * @param {Function} props.setHideSimilarStock - function to show/hide similar stock items
 * @param {Bool} props.hideSimilarStock - Bool to check if items are shown
 * @param {Bool} props.isProductDetail - Bool to check for which view the component is on
 * @param {String} props.currentStoreName - String for current location name
 * @param {String} props.currentStoreLocationId - Number for ID of current location
 * @param {String} props.tick - Image asset passed from Rails
 */

const V2SimilarStock = ({
  similarStockItems,
  setHideSimilarStock,
  hideSimilarStock,
  isProductDetail,
  currentStoreName,
  vatExclusive,
  loadingPrices,
  prices,
}) => (
  <div className="similar-stock__container similar-stock__container--v2 width-100 as-fe">
    <div className="fl similar-stock-v2 fl-col">
      <div className="fl">
        <div className="similar-stock-v2__indicator">
          <Circle fill={ctaGreen} />
        </div>
        <div className="fl-1">
          <HideShow
            className="fl ai-c"
            onClick={() => setHideSimilarStock(!hideSimilarStock)}>
            <span>
              {hideSimilarStock ? 'View similar items' : 'Hide similar items'}
            </span>
            <Arrow
              fillColor="#207600"
              isHidden={hideSimilarStock}
              direction={hideSimilarStock ? 'down' : 'up'}
            />
          </HideShow>
          <p>in stock at this {branchTermSingular}</p>
        </div>
      </div>
      <div className={hideSimilarStock ? 'd-none' : ''}>
        <SimilarStockItemsCarousel
          similarStockItems={similarStockItems}
          isProductDetail={isProductDetail}
          currentStoreName={currentStoreName}
          vatExclusive={vatExclusive}
          loadingPrices={loadingPrices}
          prices={prices}
        />
      </div>
    </div>
  </div>
);

const HideShow = styled.button`
  padding: 0;
  border: 0;
  background-color: transparent;
  width: 100%;
  color: #207600;
  text-align: left;
`;

export default V2SimilarStock;
